import ProductCompareTool from 'components/ProductPage/ProductCompareTool/ProductCompareTool.f';

export default ProductCompareTool;
